var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchPageData } from "../../fetchPageData";
import logger from "../../logger";
var fetchModule = function (type) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, endpoint, variables, res, modules, moduleData, err_1;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return __generator(this, function (_o) {
        switch (_o.label) {
            case 0:
                //type = moduleType which needs to fetched
                if (!type)
                    return [2 /*return*/, { error: false, type: type, moduleData: null }];
                baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseUrl;
                endpoint = (window === null || window === void 0 ? void 0 : window.cachedAPI) || "".concat(baseUrl, "/graphql");
                variables = {
                    site: ((_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.site) === null || _e === void 0 ? void 0 : _e.siteInternalName) || null,
                    device: "WEB",
                    includeContent: true,
                    moduleLimit: 4,
                    moduleOffset: 0,
                    languageCode: ((_j = (_h = (_g = (_f = window === null || window === void 0 ? void 0 : window.app_data) === null || _f === void 0 ? void 0 : _f.appcmsMain) === null || _g === void 0 ? void 0 : _g.languages) === null || _h === void 0 ? void 0 : _h.default) === null || _j === void 0 ? void 0 : _j.code) || "en",
                    countryCode: window === null || window === void 0 ? void 0 : window.countryCode,
                    userState: window.btoa(JSON.stringify({ "state": ["loggedOut"] })),
                    modules: [],
                    platform: 'web_browser'
                };
                if (type === "SubscriptionModule") {
                    variables["path"] = "/subscription";
                }
                if (type === "LocateModule") {
                    variables["path"] = "/locate";
                }
                if (type === "CheckoutModule") {
                    variables["path"] = "/checkout";
                }
                if (type === "AuthenticationModule") {
                    variables["path"] = "/authentication";
                }
                if (type === "TveModule") {
                    variables["path"] = "/tve";
                }
                _o.label = 1;
            case 1:
                _o.trys.push([1, 3, , 4]);
                return [4 /*yield*/, fetchPageData(variables, endpoint)];
            case 2:
                res = _o.sent();
                modules = (_m = (_l = (_k = res === null || res === void 0 ? void 0 : res.data) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.page) === null || _m === void 0 ? void 0 : _m.modules;
                moduleData = modules === null || modules === void 0 ? void 0 : modules.filter(function (module) { return (module === null || module === void 0 ? void 0 : module.moduleType) === type; });
                return [2 /*return*/, { error: false, moduleData: (moduleData === null || moduleData === void 0 ? void 0 : moduleData.length) ? moduleData[0] : {}, type: type }];
            case 3:
                err_1 = _o.sent();
                logger("Error in fetching ".concat(type, " module: ").concat(err_1), "error");
                return [2 /*return*/, { error: true, type: type, moduleData: null }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export { fetchModule };
